var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteArrowUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0846 7.08333C11.5093 7.08333 11.043 6.61696 11.043 6.04167C11.043 5.46637 11.5093 5 12.0846 5H17.293C17.8683 5 18.3346 5.46637 18.3346 6.04167V11.25C18.3346 11.8253 17.8683 12.2917 17.293 12.2917C16.7177 12.2917 16.2513 11.8253 16.2513 11.25V8.55647L11.7795 13.0282C11.3727 13.435 10.7132 13.435 10.3064 13.0282L7.91797 10.6398L3.44621 15.1116C3.03941 15.5184 2.37986 15.5184 1.97307 15.1116C1.56627 14.7048 1.56627 14.0452 1.97307 13.6384L7.1814 8.4301C7.58819 8.0233 8.24774 8.0233 8.65454 8.4301L11.043 10.8185L14.7782 7.08333H12.0846Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteArrowUp);
export default __webpack_public_path__ + "static/media/white-arrow-up.70d0ebda7a8f0bf06e63aa7423d51553.svg";
export { ForwardRef as ReactComponent };